/* ============================================================
   Catharsis — product (PDP) behaviour. Vanilla, no framework.
   - Variant selection: updates form id, price, availability, URL (?variant=)
   - Selling-plan / purchase-type sync (one-time vs subscription)
   - Gallery: thumbnail switching + optional click-to-zoom
   - Mobile sticky ATC: reveals after scrolling past the main buybox; mirrors state
   Loaded only on product templates (referenced from sections/main-product.liquid).
   ============================================================ */
(function () {
  'use strict';

  var section = document.querySelector('[data-product-section]');
  if (!section) return;

  var form = section.querySelector('[data-product-form]');
  var variantIdInput = section.querySelector('[data-variant-id]');
  var picker = section.querySelector('[data-variant-picker]');
  var sellingPlanInput = section.querySelector('[data-selling-plan-input]');
  var sectionId = section.getAttribute('data-section-id');
  var baseUrl = section.getAttribute('data-product-url');
  var selectedOffer = section.catharsisOffer || null;

  /* ---------- Variant data ---------- */
  var variants = [];
  var dataEl = section.querySelector('[data-variant-data]');
  if (dataEl) {
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
  }

  function selectedOptions() {
    if (!picker) return null;
    var opts = [];
    var fieldsets = picker.querySelectorAll('[data-option-position]');
    var seen = {};
    fieldsets.forEach(function (input) {
      var pos = input.getAttribute('data-option-position');
      if (!pos || !input.hasAttribute('data-option-input')) return;
      if (input.type === 'radio') {
        if (input.checked) { opts[pos - 1] = input.value; seen[pos] = true; }
      } else if (input.tagName === 'SELECT') {
        opts[pos - 1] = input.value; seen[pos] = true;
      }
    });
    return opts;
  }

  function matchVariant(opts) {
    if (!opts) return null;
    return variants.find(function (v) {
      return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
    }) || null;
  }

  /* ---------- Section Rendering API: refresh price/availability server-side ---------- */
  function parseDisplayedCents(text) {
    var normalized = String(text || '').replace(/[^0-9,.-]/g, '');
    if (!normalized) return null;
    var decimal = Math.max(normalized.lastIndexOf(','), normalized.lastIndexOf('.'));
    var whole = decimal === -1 ? normalized : normalized.slice(0, decimal);
    var fraction = decimal === -1 ? '' : normalized.slice(decimal + 1);
    whole = whole.replace(/[.,-]/g, '');
    if (!/^\d+$/.test(whole) || (fraction && !/^\d{1,2}$/.test(fraction))) return null;
    var cents = Number(whole) * 100 + Number((fraction || '').padEnd(2, '0'));
    return Number.isSafeInteger(cents) ? cents : null;
  }

  function emitVariantChange(variant, price) {
    if (!variant) return;
    section.dispatchEvent(new CustomEvent('catharsis:variant-change', {
      bubbles: false,
      detail: {
        id: variant.id,
        available: variant.available,
        ...(Number.isSafeInteger(price) ? { price: price } : {})
      }
    }));
  }

  function fetchSection(variant) {
    var url = baseUrl + '?variant=' + variant.id + '&section_id=' + sectionId;
    return fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // Keep every offer card on the selected variant's server prices, including unselected
        // cards. Preserve the existing radios, selection, benefits and editor block nodes.
        section.querySelectorAll('[data-packs-palier]').forEach(function (card) {
          var fresh = Array.from(doc.querySelectorAll('[data-packs-palier]')).find(function (node) {
            return node.dataset.offerKey === card.dataset.offerKey;
          });
          if (!fresh) return;
          ['variantId', 'regularPrice', 'prix', 'prixTexte', 'reference', 'referenceText', 'savings', 'savingsText', 'available', 'giftAvailable'].forEach(function (key) {
            if (fresh.dataset[key] !== undefined) card.dataset[key] = fresh.dataset[key];
          });
          var radio = card.querySelector('[data-packs-radio]');
          var freshRadio = fresh.querySelector('[data-packs-radio]');
          if (radio && freshRadio) {
            radio.disabled = freshRadio.disabled;
            radio.value = freshRadio.value;
          }
          card.classList.toggle('c-pack--indisponible', fresh.dataset.available !== 'true');
          ['.c-pack__prix', '.c-pack__economie', '.c-pack__epuise'].forEach(function (selector) {
            var old = card.querySelector(selector), next = fresh.querySelector(selector);
            if (old && next) old.replaceWith(next.cloneNode(true));
            else if (old) old.remove();
            else if (next) {
              var freshParent = next.parentElement;
              var parent = freshParent === fresh ? card : card.querySelector('.' + freshParent.classList[0]);
              if (parent) parent.append(next.cloneNode(true));
            }
          });
        });
        // Regions that are re-rendered wholesale from the server for the chosen variant.
        // Each one derives from the variant's real price or availability, so a variant switch
        // that updated the price but not the instalment amount beside it would put two
        // contradictory numbers on screen at once.
        ['[data-price-target]', '[data-payment-plan-target]'].forEach(function (sel) {
          var fresh = doc.querySelector(sel);
          var cur = section.querySelector(sel);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        });
        // Sticky bar: price (innerHTML — it can carry a struck compare-at price) and the
        // selection restate line (swatch dot + variant options), both re-rendered server-side.
        ['[data-sticky-price]', '[data-sticky-selection]'].forEach(function (sel) {
          var fresh = doc.querySelector(sel);
          var cur = section.querySelector(sel);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        });
        // Libelles des boutons d'achat (ajouter au panier / Acheter) ET le prix qu'ils portent.
        // `textContent` effacait le <span data-add-price> : apres un changement de variante,
        // le recalcul lie aux accessoires n'avait plus de cible. On remplace donc le contenu
        // (notre propre rendu serveur) et on reporte la base de prix.
        //
        // Il y a maintenant DEUX libelles possibles dans la boite d'achat — le panier et le
        // paiement direct — et ils peuvent etre presents ensemble, seuls, ou pas du tout. On
        // les apparie par leur cle (`data-add-label="atc"` / `"now"`) et jamais par leur rang :
        // un rang change des que le fondateur decoche un bouton, une cle non.
        section.querySelectorAll('[data-add-label]').forEach(function (cur) {
          var cle = cur.getAttribute('data-add-label');
          if (!cle) return;
          var fresh = doc.querySelector('[data-add-label="' + cle + '"]');
          if (!fresh) return;
          cur.innerHTML = fresh.innerHTML;
          var b = fresh.getAttribute('data-prix-base');
          if (b) cur.setAttribute('data-prix-base', b);
        });
        recalculerPrixAchat();
        // The offer picker retains its selected bundle artwork, but its payable CatLang variant
        // must be the exact variant just validated above.  Read the server-rendered amount rather
        // than inventing a client price or carrying the previous card's price into checkout.
        var displayed = freshText(doc.querySelector('[data-price-target] .price__amount'));
        emitVariantChange(variant, parseDisplayedCents(displayed));
      })
      .catch(function () { /* keep client-side state on failure */ });
  }

  function freshText(node) {
    return node ? node.textContent : '';
  }

  /* ---------- Le bouton d'achat suit les accessoires coches ----------
     Releve du juge, 9 septembre : « le CTA affiche · 599,00 EUR avant ET apres cochage d'un
     accessoire a 19,90 EUR », panier verifie a 618,90 EUR. Le bouton annoncait donc un montant
     qu'il ne facturait pas — sur le seul geste qui rapporte de l'argent. Le prix du bouton se
     recalcule maintenant a chaque changement de case : base de la variante + accessoires
     retenus. On ecrit du TEXTE, jamais du balisage : le prix barre appartient au rendu serveur.
     La base vit dans `data-prix-base`, que le rechargement de variante reecrit avec le reste. */
  function formaterPrix(cents) {
    var devise = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency', currency: devise
      }).format(cents / 100);
    } catch (err) {
      return (cents / 100).toFixed(2) + ' \u20AC';
    }
  }

  function supplementAccessoires() {
    var somme = 0;
    section.querySelectorAll('[data-addon-variant]').forEach(function (c) {
      if (!c.checked) return;
      var p = parseInt(c.getAttribute('data-addon-prix'), 10);
      if (!isNaN(p)) somme += p;
    });
    return somme;
  }

  function recalculerPrixAchat() {
    var supplement = supplementAccessoires();
    // Tous les libelles d'achat, pas seulement le premier : « Ajouter au panier » et
    // « Acheter » peuvent afficher le prix en meme temps, et deux montants differents dans la
    // meme boite d'achat, c'est exactement le defaut releve le 9 septembre sur le seul geste
    // qui rapporte de l'argent.
    section.querySelectorAll('[data-add-label]').forEach(function (etiquette) {
      var base = Number.isSafeInteger(selectedOffer && selectedOffer.unitPrice)
        ? selectedOffer.unitPrice : parseInt(etiquette.getAttribute('data-prix-base'), 10);
      if (isNaN(base)) return;
      etiquette.setAttribute('data-prix-base', String(base));
      var cible = etiquette.querySelector('[data-add-price]');
      if (cible) cible.textContent = ' \u00B7 ' + formaterPrix(base + supplement);
    });
  }

  section.addEventListener('change', function (e) {
    var c = e.target && e.target.closest && e.target.closest('[data-addon-variant]');
    if (c) recalculerPrixAchat();
  });

  function setAvailability(variant) {
    var addBtn = section.querySelector('[data-add-to-cart]');
    var stickyBtn = section.querySelector('[data-sticky-add]');
    // Le bouton de paiement direct est un bouton d'achat comme les autres : il ne doit jamais
    // rester cliquable sur une variante qu'on ne peut pas vendre.
    var buyNowBtns = Array.prototype.slice.call(section.querySelectorAll('[data-buy-now]'));
    // Pack selection can add a stock-dependent gift.  The form stays bound to the CatLang
    // variant, but a Pack Français must be unavailable when either component is unavailable.
    var available = selectedOffer ? selectedOffer.available : (variant && variant.available);
    [addBtn, stickyBtn].concat(buyNowBtns).forEach(function (btn) {
      if (!btn) return;
      if (available) { btn.removeAttribute('disabled'); btn.removeAttribute('aria-disabled'); }
      else { btn.setAttribute('disabled', ''); btn.setAttribute('aria-disabled', 'true'); }
    });
  }

  section.addEventListener('catharsis:offer-change', function (event) {
    selectedOffer = event.detail || null;
    setAvailability({ available: selectedOffer && selectedOffer.available });
    recalculerPrixAchat();
  });

  function updateSelectedValueLabels() {
    if (!picker) return;
    picker.querySelectorAll('[data-option-position]').forEach(function (fs) {
      if (fs.tagName !== 'FIELDSET') return;
      var pos = fs.getAttribute('data-option-position');
      var label = fs.querySelector('[data-option-selected-value]');
      if (!label) return;
      var checked = fs.querySelector('input[type="radio"]:checked');
      var select = fs.querySelector('select');
      if (checked) label.textContent = checked.value;
      else if (select) label.textContent = select.value;
    });
  }

  // Mark every option value that leads to nothing buyable, given what else is currently chosen.
  //
  // Liquid paints this on first render, but availability is a property of the WHOLE combination:
  // choose "Noir" and some sizes may go out of stock, choose "M" and some colours may. Only the
  // client knows the current combination, so only the client can keep the marks honest after the
  // first click. Without this, the server's first answer freezes and starts lying.
  function updateOptionAvailability() {
    if (!picker || !variants.length) return;
    var chosen = selectedOptions();
    picker.querySelectorAll('fieldset[data-option-position]').forEach(function (fs) {
      var pos = parseInt(fs.getAttribute('data-option-position'), 10) - 1;
      fs.querySelectorAll('[data-option-value]').forEach(function (label) {
        var value = label.getAttribute('data-option-value');
        // Hold every OTHER option at its current choice and ask whether this value can be bought.
        var probe = chosen.slice();
        probe[pos] = value;
        var reachable = variants.some(function (v) {
          if (!v.available) return false;
          return probe.every(function (opt, i) { return opt == null || v.options[i] === opt; });
        });
        label.classList.toggle('is-unavailable', !reachable);
        if (reachable) label.removeAttribute('data-unavailable');
        else label.setAttribute('data-unavailable', '');
        var note = label.querySelector('[data-unavailable-note]');
        if (note) note.hidden = reachable;
      });
    });
  }

  function onVariantChange() {
    var opts = selectedOptions();
    var variant = matchVariant(opts);
    updateSelectedValueLabels();
    updateOptionAvailability();
    if (!variant) { setAvailability(null); return; }


    // The product form's single source of truth for the variant. The sticky bar deliberately
    // carries no id input of its own — it submits this same form (see product-sticky-atc.liquid).
    if (variantIdInput) variantIdInput.value = variant.id;

    // URL
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());

    // Gallery follows the variant: show its featured media if the gallery exposes it.
    if (variant.featured_media_id != null) showGalleryMedia(variant.featured_media_id);

    setAvailability(variant);
    // This immediate event synchronises the cart variant before the Section Rendering request
    // returns.  A second event with the rendered price follows in `fetchSection`.
    emitVariantChange(variant, null);
    fetchSection(variant);
  }

  if (picker) {
    picker.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-input]')) onVariantChange();
    });
  }

  /* ---------- Selling plan / purchase-type ---------- */
  function setSellingPlan(planId) {
    // One input only. The sticky bar used to carry a duplicate name="selling_plan" which, because
    // its wrapping <form> was dropped as invalid nesting, landed in THIS form — giving the
    // submission two competing subscription values.
    if (sellingPlanInput) sellingPlanInput.value = planId || '';
  }

  // Subscribe block radio list
  var subscribeBlock = section.querySelector('[data-subscribe]');
  if (subscribeBlock) {
    var subCard = subscribeBlock.querySelector('[data-subscribe-card]');
    var subToggle = subscribeBlock.querySelector('[data-subscribe-toggle]');
    var subSelect = subscribeBlock.querySelector('[data-plan-select]');

    // The switch answers "am I subscribing"; the select answers "how often". Keeping them apart
    // is the whole point of the redesign, so the plan id is derived from BOTH rather than read
    // off whichever control the customer happened to touch.
    function syncSubscription() {
      var on = subToggle ? subToggle.checked : false;
      if (subCard) subCard.classList.toggle('is-on', on);
      setSellingPlan(on && subSelect ? subSelect.value : '');
    }

    subscribeBlock.addEventListener('change', function (e) {
      if (e.target.closest('[data-subscribe-toggle]') || e.target.closest('[data-plan-select]')) {
        syncSubscription();
        return;
      }
      // The earlier radio-list layout is still supported: a merchant who switches back to it,
      // or an app that injects one, keeps working without a second code path to maintain.
      var choice = e.target.closest('[data-plan-choice]');
      if (choice) setSellingPlan(choice.value);
    });

    // Reflect the server-rendered state on load rather than assuming "off" and drifting.
    syncSubscription();
  }

  // Purchase-type toggle in buy-buttons: when "subscription" is picked but no subscribe block
  // is present, fall back to the first available plan; show the note.
  var purchaseType = section.querySelector('[data-purchase-type]');
  if (purchaseType) {
    var note = section.querySelector('[data-purchase-note]');
    purchaseType.addEventListener('change', function () {
      var sub = section.querySelector('[data-purchase-subscription]');
      var subscribing = sub && sub.checked;
      if (note) note.hidden = !subscribing;
      // If a subscribe block exists it owns the plan id; only act when it doesn't.
      if (!subscribeBlock) {
        if (subscribing) {
          var firstPlan = section.querySelector('[data-plan-choice][data-plan-id]');
          setSellingPlan(firstPlan ? firstPlan.value : '');
        } else {
          setSellingPlan('');
        }
      }
    });
  }

  /* ---------- Gallery ---------- */
  var gallery = section.querySelector('[data-product-gallery]');

  var galleryTrack = gallery && gallery.querySelector('[data-gallery-track]');
  var galleryIndex = gallery && gallery.querySelector('[data-gallery-index]');
  var calmMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reflect which slide is current, WITHOUT hiding the others.
  //
  // The gallery used to set `hidden` on every slide but one. That is the correct move for a
  // one-at-a-time stage and exactly wrong for a scroller: hiding the neighbours removes the
  // peek, and the peek is the only thing telling a thumb there is more to see. Selection is now
  // a class and an aria state; the browser's own scrolling does the rest.
  function markGalleryMedia(id) {
    if (!gallery || id == null) return null;
    id = String(id);
    var target = null;
    gallery.querySelectorAll('[data-gallery-slide]').forEach(function (s) {
      var match = s.getAttribute('data-media-id') === id;
      if (match) target = s;
      s.classList.toggle('is-active', match);
    });
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      var on = t.getAttribute('data-media-id') === id;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-current', on ? 'true' : 'false');
    });
    if (target && galleryIndex) {
      var all = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
      galleryIndex.textContent = String(all.indexOf(target) + 1);
    }
    return target;
  }

  // Selecting a variant scrolls its photograph into view rather than swapping the DOM.
  function showGalleryMedia(id) {
    var target = markGalleryMedia(id);
    if (!target || !galleryTrack) return;
    galleryTrack.scrollTo({ left: target.offsetLeft - galleryTrack.offsetLeft, behavior: calmMotion ? 'auto' : 'smooth' });
  }

  if (gallery) {
    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (thumb) {
        showGalleryMedia(thumb.getAttribute('data-media-id'));
        return;
      }
      if (gallery.hasAttribute('data-zoom-enabled')) {
        var img = e.target.closest('.product-gallery__image');
        if (img) {
          var slide = img.closest('[data-gallery-slide]');
          if (slide) slide.classList.toggle('is-zoomed');
        }
      }
    });
  }

  // Swiping is the primary control now, so the counter and the thumbnails have to follow the
  // finger. An IntersectionObserver rooted on the track reports which slide holds the middle;
  // a scroll listener would fire on every frame and still need this arithmetic.
  if (galleryTrack && 'IntersectionObserver' in window) {
    var trackObserver = new IntersectionObserver(function (entries) {
      var best = null;
      entries.forEach(function (en) {
        if (en.isIntersecting && (!best || en.intersectionRatio > best.intersectionRatio)) best = en;
      });
      if (best) markGalleryMedia(best.target.getAttribute('data-media-id'));
    }, { root: galleryTrack, threshold: [0.5, 0.75, 1] });
    galleryTrack.querySelectorAll('[data-gallery-slide]').forEach(function (s) { trackObserver.observe(s); });
  }

  /* ---------- Mobile sticky ATC ---------- */
  var sticky = section.querySelector('[data-sticky-atc]');
  var buybox = section.querySelector('[data-buy-buttons]');
  if (sticky && buybox && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    sticky.classList.remove('is-visible'); // start hidden via transform
    var stickyFrame = 0;
    function updateStickyPosition() {
      stickyFrame = 0;
      var rect = buybox.getBoundingClientRect();
      var footer = document.querySelector('footer.footer');
      var footerReached = footer && footer.getBoundingClientRect().top < window.innerHeight;
      sticky.classList.toggle('is-visible', rect.height > 0 && rect.bottom <= 0 && !footerReached);
    }
    function scheduleStickyPosition() {
      if (!stickyFrame) stickyFrame = requestAnimationFrame(updateStickyPosition);
    }
    // A jump can move the buybox from below to above the viewport without ever intersecting
    // it. The observer alone then emits no new entry. Also handle scroll/hash/history jumps.
    var io = new IntersectionObserver(scheduleStickyPosition, { threshold: 0 });
    io.observe(buybox);
    window.addEventListener('scroll', scheduleStickyPosition, { passive: true });
    window.addEventListener('resize', scheduleStickyPosition, { passive: true });
    updateStickyPosition();
    document.addEventListener('shopify:section:unload', function unloadSticky(event) {
      if (event.target !== section && !event.target.contains(section)) return;
      io.disconnect();
      cancelAnimationFrame(stickyFrame);
      window.removeEventListener('scroll', scheduleStickyPosition);
      window.removeEventListener('resize', scheduleStickyPosition);
      document.removeEventListener('shopify:section:unload', unloadSticky);
    });
  }

  /* ---------- Move express checkout into the buy-buttons slot ---------- */
  var expressSource = section.querySelector('[data-dynamic-checkout-source]');
  var expressSlot = section.querySelector('[data-dynamic-checkout-slot]');
  if (expressSource && expressSlot) {
    while (expressSource.firstChild) expressSlot.appendChild(expressSource.firstChild);
    expressSource.remove();
  } else if (expressSource) {
    // Pas de logement, donc pas de boutons express. Deux cas mènent ici, et le resultat voulu est
    // le meme : le fondateur a decoche « Afficher les paiements express » dans le bloc « Boutons
    // d'achat », ou il a retire le bloc entier de la fiche.
    //
    // On RETIRE le noeud au lieu de le reveler sur place. Une version anterieure le laissait
    // apparaitre a son emplacement d'origine, en haut du formulaire : le bouton violet « Acheter
    // avec Shop » se retrouvait SEUL, pleine largeur, au-dessus de la galerie. C'est la premiere
    // capture du mandat du fondateur, une page cassee.
    expressSource.remove();
  }

  // Initialize labels on load.
  updateSelectedValueLabels();
  // Run once on load so the marks the server painted are confirmed by the same rule that will
  // maintain them. If the two ever disagree, they disagree immediately and visibly, not later.
  updateOptionAvailability();
})();
